




















































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import * as types from '@/store/content/types'
import * as accountTypes from '@/store/account/types'
import Content from '@/store/models/content'
import VBackButton from '@/components/VBackButton.vue'
import VButton from '@/components/VButton.vue'
import VDropdown from '@/components/VDropdown.vue'
import VContentList from '@/components/VContentList.vue'
import VModal from '@/components/VModal.vue'
import StarOutlineIcon from 'vue-material-design-icons/StarOutline.vue'
import StarIcon from 'vue-material-design-icons/Star.vue'
import StarHalfIcon from 'vue-material-design-icons/StarHalfFull.vue'

@Component({
  components: {
    VBackButton,
    VButton,
    VDropdown,
    VContentList,
    VModal,
    StarIcon,
    StarHalfIcon,
    StarOutlineIcon
  }
})
export default class Cinema extends Vue {
  @Action('contentById', { namespace: 'content' }) contentById!: types.ContentByIdAction
  @Action('relatedContent', { namespace: 'content' }) getRelatedContent!: types.RelatedContentAction
  @Action('rate', { namespace: 'content' }) rateAction!: types.RateAction;

  @Action('addFavorite', { namespace: 'account' }) addFavorite!: accountTypes.AddFavoriteAction
  @Action('favorites', { namespace: 'account' }) loadFavorites!: accountTypes.FavoritesAction
  @Action('removeFavorite', { namespace: 'account' }) removeFavorite!: accountTypes.RemoveFavoriteAction
  @Getter('userInfo', { namespace: 'account' }) userInfo!: accountTypes.AccountState

  private content = new Content()
  private relatedContent: { name: string; related_content: Content[] }[] = []
  private showRatingModal = false
  private loadingRating = false
  private selectedReview = -1
  private textSelect = 2

  private created () {
    this.loadContent()
  }

  @Watch('$route')
  private loadContent () {
    if (this.userInfo.loggedIn) {
      this.selectedReview = this.content.userRating || -1
      this.loadFavorites()
    }
    this.contentById(this.$route.params.contentId).then((response) => {
      this.content = response
    })
    this.getRelatedContent(this.$route.params.contentId).then((response) => {
      this.relatedContent = response
    })
  }

  private submitReview () {
    this.loadingRating = true
    this.rateAction({ contentId: this.content.user_id.toString(), rating: this.selectedReview }).then((response) => {
      this.showRatingModal = false
      this.contentById(this.$route.params.contentId).then((response) => {
        this.content = response
      })
    }).finally(() => {
      this.loadingRating = false
    })
  }

  private uploadFavorite () {
    this.addFavorite({
      category: parseInt(this.$route.params.category),
      book: parseInt(this.$route.params.id),
      content: this.content.user_id
    })
  }

  private get isFavorite () {
    return this.userInfo.favorites.map((favorite) => favorite.user_id).includes(this.content.user_id)
  }

  private get videoId () {
    if (this.content.user_id === -1) { // If content is not loaded
      return ''
    }
    return this.content.url.split(/[=&]+/)[1]
  }
}

